import generateCalendar from "antd/es/calendar/generateCalendar";
import type { DateTime } from "luxon";
import luxonGenerateConfig from "rc-picker/lib/generate/luxon";

const Calendar = generateCalendar<DateTime>(luxonGenerateConfig);

export default Calendar;
